<section class="home-page">

    <div class="slider">
        <div class="slide">
            <div class="slide-content-1">
                <h2>Contact Centre Assistance Meets Vocbot</h2>
                <h4>
                    Transforming how calls are handled, Vocbot brings a new era of ease to the contact centre industry.
                </h4>
            </div>
        </div>
        <div class="slide">
            <div class="slide-content-1">
                <h2>Enhancing Education with Vocbot Assistance</h2>
                <h4>
                    Vocbot is revolutionizing the landscape of
                    education by offering personalized assistance and support to
                    learners of all ages.
                </h4>
            </div>
        </div>
        <div class="slide">
            <div class="slide-content-1">
                <h2>Meet Vocbot, Your Companion to Get Customer Insights</h2>
                <h4>
                    Vocbot is your go-to companion for understanding your customers like never before. It collects
                    feedback and can provide you with real-time insights, helping you tailor your offerings to your
                    customers’ needs.
                </h4>
            </div>
        </div>
        <div class="slide">
            <div class="slide-content-1">
                <h2>
                    Enhance your customers’ experience with the aid of Vocbot’s AI-enabled voice.
                </h2>
                <h4>
                    • Cut Down the Operation Cost up to 60% <br>
                    • Deployment in 48hrs <br>
                    • Ease of use <br>
                    • No More Language Barrier <br>
                    • Inbound & Outbound Solutions <br>
                    • No More Waiting Time <br>
                    • Completely Answered Calls <br>
                    • 24*7 Uptime

                </h4>
            </div>
        </div>
        <div class="slide">
            <div class="slide-content-1">
                <h2>
                    Streamline Outreach with our Vocbot Bulk Whatsapp Message Sender
                </h2>
                <h4>
                    Vocbot simplifies bulk WhatsApp messaging, automating outreach efforts for maximum efficiency.
                </h4>
            </div>
        </div>

    </div>



    <div class="ai-services-area ptb-100">
        <div class="container-fluid">
            <div class="section-title title-with-underline" style="max-width: 1275px !important; margin-bottom: 60px"
                data-aos="fade-down">
                <h2>
                    Our Services With Artificial Intelligence
                </h2>
                <p>
                    Explore a diverse array of services empowered by Artificial
                    Intelligence with us.
                </p>
                <img src="assets/img/RO.gif" style="height: 30px; margin-top: 5px" />
            </div>

            <div class="row justify-content-center">
                <div class="col-lg-3 col-md-6 col-sm-6 service-card" data-aos="zoom-in-down">
                    <a routerLink="/inBound">
                    <div class="ai-services-card" style="
                            background-image: url(assets/img/cardbg/what-removebg-preview.png);
                        ">
                        <div class="row justify-content-center">
                            <div class="services-image">
                                <img src="assets/img/Male agent working in call center.gif" alt="image"
                                    style="max-width: 100%" />
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="services-content">
                                <h3>
                                    <a routerLink="/inBound">Inbound Call Center </a>
                                </h3>

                                <a routerLink="/inBound" class="arrow">→</a>

                            </div>
                        </div>
                    </div>
                </a>
                </div>

                <div class="col-lg-3 col-md-6 col-sm-6 service-card" data-aos="zoom-in-down">
                    <a routerLink="/outBound">
                    <div class="ai-services-card" style="
                            background-image: url(assets/img/cardbg/outboundbg-removebg-preview.png);
                        ">
                        <div class="row justify-content-center">
                            <div class="services-image">
                                <img src="assets/img/Push Marketing.gif" alt="image" style="max-width: 100%" />
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="services-content">
                                <h3>
                                    <a routerLink="/outBound"> Outbound Marketing</a>
                                </h3>

                                <a routerLink="/outBound" class="arrow">→</a>
                            </div>
                        </div>
                    </div>
                </a>
                </div>

                <div class="col-lg-3 col-md-6 col-sm-6 service-card" data-aos="zoom-in-down">
                    
                    <a routerLink="/bulkWhatsApp">
                    <div class="ai-services-card" style="
                            background-image: url(assets/img/cardbg/tourbg-removebg-preview.png);
                        ">
                        <div class="row justify-content-center">
                            <div class="services-image">
                                <img src="assets/img/Whatsapp.gif" alt="image" style="max-width: 100%" />
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="services-content">
                                <h3>
                                    <a routerLink="/bulkWhatsApp">WhatsApp Sender</a>
                                </h3>

                                <a routerLink="/bulkWhatsApp" class="arrow">→</a>
                            </div>
                        </div>
                    </div>
                    </a>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6 service-card" data-aos="zoom-in-down">

                    <a routerLink="/bulk-sms-sender">
                    <div class="ai-services-card" style="
                           background-image: url(assets/img/cardbg/edubg-removebg-preview.png);
                        ">
                        <div class="row justify-content-center">
                            <div class="services-image">
                                <img src="assets/img/Sms.gif" alt="image" style="max-width: 100%" />
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="services-content">
                                <h3>
                                    <a routerLink="/bulk-sms-sender">Bulk Messenger</a>
                                </h3>

                                <a routerLink="/bulk-sms-sender" class="arrow">→</a>
                            </div>
                        </div>
                    </div>
                </a>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6 service-card" data-aos="zoom-in-down">
                    <a routerLink="/email">
                    <div class="ai-services-card" style="
                            background-image: url(assets/img/cardbg/retailbg-removebg-preview.png);
                        ">
                        <div class="row justify-content-center">
                            <div class="services-image">
                                <img src="assets/img/Email-1.gif" alt="image"
                                    style="max-width: 100%" />
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="services-content">
                                <h3>
                                    <a routerLink="/email">Email </a>
                                </h3>

                                <a routerLink="/email" class="arrow">→</a>

                            </div>
                        </div>
                    </div>
                </a>
                </div>

                <div class="col-lg-3 col-md-6 col-sm-6 service-card" data-aos="zoom-in-down">
                    <a routerLink="/whatsapp-meta">
                    <div class="ai-services-card" style="
                            background-image: url(assets/img/cardbg/what-removebg-preview.png);
                        ">
                        <div class="row justify-content-center">
                            <div class="services-image">
                                <img src="assets/img/WhatsApp-3.gif" alt="image" style="max-width: 100%" />
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="services-content">
                                <h3>
                                    <a routerLink="/whatsapp-meta"> Whatsapp Meta</a>
                                </h3>

                                <a routerLink="/whatsapp-meta" class="arrow">→</a>
                            </div>
                        </div>
                    </div>
                </a>
                </div>

                <div class="col-lg-3 col-md-6 col-sm-6 service-card" data-aos="zoom-in-down">
                    
                    <a routerLink="/rcs">
                    <div class="ai-services-card" style="
                            background-image: url(assets/img/cardbg/edubg-removebg-preview.png);
                        ">
                        <div class="row justify-content-center">
                            <div class="services-image">
                                <img src="assets/img/Robot.gif" alt="image" style="max-width: 100%" />
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="services-content">
                                <h3>
                                    <a routerLink="/rcs">RCS</a>
                                </h3>

                                <a routerLink="/rcs" class="arrow">→</a>
                            </div>
                        </div>
                    </div>
                    </a>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6 service-card" data-aos="zoom-in-down">

                    <a routerLink="/ivr">
                    <div class="ai-services-card" style="
                           background-image: url(assets/img/cardbg/e-combg-removebg-preview.png);
                        ">
                        <div class="row justify-content-center">
                            <div class="services-image">
                                <img src="assets/img/ivr-bot.gif" alt="image" style="max-width: 100%" />
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="services-content">
                                <h3>
                                    <a routerLink="/ivr">OBD / IVR</a>
                                </h3>

                                <a routerLink="/ivr" class="arrow">→</a>
                            </div>
                        </div>
                    </div>
                </a>
                </div>

            </div>
        </div>
    </div>

    <!-- AI Solution Area -->
    <div class="ai-solution-area pb-100">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="col-lg-5 col-md-6 col-sm-12" data-aos="zoom-in-right">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/chat-today.png" alt="image" style="max-width: 65% ;margin-top: -90px;" />
                    </div>
                </div>

                <div class="col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px  ;
                                line-height: 59px  ;
                                margin-bottom: 0px  ;
                                color: white !important;
                            " data-aos="zoom-in-left">
                            Create Tomorrow's Contact Center Today!
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" data-aos="zoom-in-left" />
                        <p style="
                                font-size: 25px  ;
                                line-height: 38px  ;
                                margin-top: 50px;
                                margin-bottom: 35px  ;
                                color: white !important;
                            ">
                            We're at the forefront of advancing human-machine communication. Collaborate with us to
                            infuse automation and human touch into your communication using Al, which understands the
                            user's context.
                        </p>

                        <ul class="features-list" data-aos="zoom-in-left">
                            <li>
                                <span><i class="bx bx-check-double"></i>
                                    Unmatched Personalized Object Detection
                                </span>
                            </li>
                            <li>
                                <span><i class="bx bx-check-double"></i> Lifelike Al Creations
                                </span>
                            </li>
                            <li>
                                <span><i class="bx bx-check-double"></i>
                                    Pioneering Innovation in Machine Learning</span>
                            </li>
                        </ul>
                        <div class="solution-btn" style="margin-top: 60px" data-aos="zoom-in-left">
                            <a routerLink="/contact" class="btn btn-primary">
                                Learn More
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-bg"></div>
        </div>
    </div>






    <!-- AI Services Area -->
    <div class="ai-services-area ptb-100">
        <div class="container-fluid">
            <div class="section-title title-with-underline" style="max-width: 1275px !important" data-aos="fade-down">
                <h2>
                    Customised Solutions for Industry Needs with the Aid of AI
                </h2>

                <img src="assets/img/RO.gif" style="height: 30px" />
            </div>

            <div class="row justify-content-center">

                <!-- education    -->
                <div class="col-lg-4 col-md-6 col-sm-6 service-card" data-aos="zoom-in-down">
                    <a routerLink="/education">
                    <div class="ai-services-card" style="
                            background-image: url(assets/img/cardbg/inboundbg-removebg-preview.png);
                        ">
                        <div class="row justify-content-center">
                            <div class="services-image">
                                <img src="assets/img/Education.gif" alt="image" style="max-width: 91%" />
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="services-content">
                                <h3>
                                    <a routerLink="/education">Education</a>
                                </h3>

                                <a routerLink="/education" class="arrow">→</a>
                            </div>
                        </div>
                    </div>
                </a>
                </div>
                <!--healthcare  -->
                <div class="col-lg-4 col-md-6 col-sm-6 service-card" data-aos="zoom-in-down">
                    <a routerLink="/healthcare">
                    <div class="ai-services-card" style="
                            background-image: url(assets/img/cardbg/tourbg-removebg-preview.png);
                        ">
                        <div class="row justify-content-center">
                            <div class="services-image">
                                <img src="assets/img/Examination.gif" alt="image" style="max-width: 91%" />
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="services-content">
                                <h3>
                                    <a routerLink="/healthcare">Healthcare</a>
                                </h3>

                                <a routerLink="/healthcare" class="arrow" style="
                                        position: absolute;
                                        bottom: 4px;
                                        right: 40px;
                                        color: #4c118e;
                                        font-size: 52px;
                                    ">→</a>
                            </div>
                        </div>
                    </div>
                </a>
                </div>

                <!--e-commerce  -->
                <div class="col-lg-4 col-md-6 col-sm-6 service-card" data-aos="zoom-in-down">
                    <a routerLink="/ecommerce">
                    <div class="ai-services-card" style="
                            background-image: url(assets/img/cardbg/edubg-removebg-preview.png);
                        ">
                        <div class="row justify-content-center">
                            <div class="services-image">
                                <img src="assets/img/E Commerce.gif" alt="image" style="max-width: 91%" />
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="services-content">
                                <h3>
                                    <a routerLink="/ecommerce">E-Commerce</a>
                                </h3>
                                <!-- <p>
                                In E-commerce, AI is crucial for predicting
                                trends, personalizing experiences, and enhancing
                                efficiency to meet consumer demands, fostering
                                growth and maintaining a competitive edge in the
                                industry.
                            </p> -->
                                <a routerLink="/ecommerce" class="arrow" style="
                                        position: absolute;
                                        bottom: 4px;
                                        right: 40px;
                                        color: #4c118e;
                                        font-size: 52px;
                                    ">→</a>
                            </div>
                        </div>
                    </div>
                </a>
                </div>
                <!--retail  -->
                <div class="col-lg-4 col-md-6 col-sm-6 service-card" data-aos="zoom-in-down">
                    <a routerLink="/retail">
                    <div class="ai-services-card" style="
                         background-image: url(assets/img/cardbg/e-combg-removebg-preview.png);
                     ">
                        <div class="row justify-content-center">
                            <div class="services-image">
                                <img src="assets/img/Shopping Trolley.gif" alt="image" style="max-width: 91%" />
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="services-content">
                                <h3>
                                    <a routerLink="/retail">Retail </a>
                                </h3>

                                <a routerLink="/retail" class="arrow">→</a>
                            </div>
                        </div>
                    </div>
                </a>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6 service-card" data-aos="zoom-in-down">
                    <a routerLink="/tour-and-travels">
                    <div class="ai-services-card" style="
                      background-image: url(assets/img/cardbg/retailbg-removebg-preview.png);
                  ">
                        <div class="row justify-content-center">
                            <div class="services-image">
                                <img src="assets/img/World Tour.gif" alt="image" style="max-width: 91%" />
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="services-content">
                                <h3>
                                    <a routerLink="/tour-and-travels">Tour and Travels </a>
                                </h3>

                                <a routerLink="/tour-and-travels" class="arrow">→</a>
                            </div>
                        </div>
                    </div>
                </a>
                </div>
                <!--Utilties  -->
                <div class="col-lg-4 col-md-6 col-sm-6 service-card" data-aos="zoom-in-down">
                    <a routerLink="/Utilities">
                    <div class="ai-services-card" style="
                      background-image: url(assets/img/cardbg/outboundbg-removebg-preview.png);
                  ">
                        <div class="row justify-content-center">
                            <div class="services-image">
                                <img src="assets/img/Setting.gif" alt="image" style="max-width: 92%" />
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="services-content">
                                <h3>
                                    <a routerLink="/Utilities">Utilities</a>
                                </h3>

                                <a routerLink="/Utilities" class="arrow">→</a>
                            </div>
                        </div>
                    </div>
                </a>
                </div>


            </div>
        </div>
    </div>

    <!-- Handle Area -->
    <div class="handle-area ptb-100">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class=" text col-lg-6 col-md-6 col-sm-12" data-aos="fade-down">
                    <div class="ai-handle-content">
                        <h3 style=" 
                        font-size: 44.8px  ;
                        line-height: 59px  ;
                        margin-bottom: 0px  ;
                    ">
                            Focus On What Matters. Vocbot Handles the Rest
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="color: white;  font-size: 25px ;
                        line-height: 38px ;
                        margin-top: 50px;
                        margin-bottom: 35px;">
                            Work smarter, not harder. Speak your way to efficiency with Vocbot.
                        </p>
                        <ul class="features-list" data-aos="zoom-in-left">
                            <li>
                                <span><i class="bx bx-check-double"></i>
                                    Increased Efficiency
                                </span>
                            </li>
                            <li>
                                <span><i class="bx bx-check-double"></i>
                                    Cost Savings
                                </span>
                            </li>
                            <li>
                                <span><i class="bx bx-check-double"></i> Improved
                                    Accuracy</span>
                            </li>
                        </ul>


                        <div class="solution-btn" style="margin-top: 60px; border-radius: 5px" data-aos="fade-down">
                            <a routerLink="/contact" class="btn btn-primary">
                                Learn More
                            </a>
                        </div>
                    </div>
                </div>

                <div class="media col-lg-6 col-md-6 col-sm-12" data-aos="fade-down">
                    <div class="ai-handle-wrap-image">
                        <img src="assets/img/1212.png" alt="image" style="max-width: 80%" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Line Layout -->
    <!-- <div class="container-fluid">
        <div class="full-width-container app-overview">
            <div class="content">
                <h1 class="app-overview-widget-main-heading">
                    Simple, Fast &amp; Secure
                </h1>
                <div class="app-overview-widget-container">
                    <div class="app-overview-widget-container__collapsible-container">
                        <h1 class="app-overview-widget-heading">
                            Simple, Fast &amp; Secure
                        </h1>
                        <div class="app-overview-widget-container__collapsible-container__item">
                            <div>
                                <h2>One app for all things Solution</h2>
                            </div>
                            <p>
                                Whether you're at home or on the go, paying is easy and convenient. Simply choose your
                                preferred method - UPI, the PhonePe wallet, or your trusty debit and credit cards.
                            </p>
                            <span class="content-bar"></span>
                        </div>
                        <div class="app-overview-widget-container__collapsible-container__item">
                            <div>
                                <h2>
                                    Your gateway to a world of convenience.
                                </h2>
                            </div>
                            <p>
                                Ready to take control of your finances like never before? Just let me know what you
                                need, and I'll make it happen!
                            </p>
                            <span class="content-bar"></span>
                        </div>
                        <div class="app-overview-widget-container__collapsible-container__item">
                            <div>
                                <h2>
                                    Ready to take control of your finances like never before
                                </h2>
                            </div>
                            <p>
                                Book flights, order food or buy groceries. Use
                                all your favourite apps without downloading
                                them.
                            </p>
                        </div>
                    </div>

                    <div class="app-overview-widget-container__video-container ml-4" title="Title hai"
                        style="justify-content: center; align-items: center">
                        <img src="assets/img/Call Center (3).gif" style="
                                max-width: 78%;
                                float: right;
                                padding-right: 126px;
                            " />
                    </div>
                </div>
            </div>
        </div>
    </div> -->


    <!-- <div class="testimonial">
        <div class="container-fluid">
            <div class="row">
                <div class="feedback-area">
                    <div class="section-title title-with-underline">
                        <h2>
                            Our Clients Feedback On Our AI & Big Data
                            Services
                        </h2>
                       
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="carousel slide" data-ride="carousel" id="quote-carousel">
                      
                        <div class="carousel-inner text-center" data-aos="fade-down">
                       
                            <div class="item active">
                                <blockquote>
                                    <div class="row">
                                        <div class="col-sm-8 col-md-8 col-sm-offset-2">
                                            <p style="margin: 30px">
                                                "Vocbot is amazing! Used it for
                                                language learning, and the AI
                                                conversations are engaging and
                                                accurate. It's a game-changer in
                                                online experiences."
                                            </p>
                                            <p><small>Someone famous</small></p>
                                            <ul class="rating">
                                                <li><i class="bx bxs-star"></i></li>
                                                <li><i class="bx bxs-star"></i></li>
                                                <li><i class="bx bxs-star"></i></li>
                                                <li><i class="bx bxs-star"></i></li>
                                                <li><i class="bx bxs-star"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                </blockquote>
                            </div>

                      
                            <div class="item">
                                <blockquote>
                                    <div class="row">
                                        <div class="col-sm-8 col-md-8 col-sm-offset-2">
                                            <p style="margin: 30px">
                                                "Vocbot has potential but could
                                                improve response time and expand
                                                topic range. With refinements, it
                                                could be an even more valuable
                                                tool."
                                            </p>
                                            <p><small>Someone famous</small></p>
                                            <ul class="rating">
                                                <li><i class="bx bxs-star"></i></li>
                                                <li><i class="bx bxs-star"></i></li>
                                                <li><i class="bx bxs-star"></i></li>
                                                <li><i class="bx bxs-star"></i></li>
                                                <li><i class="bx bxs-star"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                </blockquote>
                            </div>
   
                            <div class="item">
                                <blockquote>
                                    <div class="row">
                                        <div class="col-sm-8 col-md-8 col-sm-offset-2">
                                            <p style="margin: 30px">
                                                "Vocbot is intriguing, but responses
                                                sometimes feel scripted. It's a
                                                decent start, and I'm curious to see
                                                how it evolves over <br />
                                                time."
                                            </p>
                                            <p><small>Someone famous</small></p>
                                            <ul class="rating">
                                                <li><i class="bx bxs-star"></i></li>
                                                <li><i class="bx bxs-star"></i></li>
                                                <li><i class="bx bxs-star"></i></li>
                                                <li><i class="bx bxs-star"></i></li>
                                                <li><i class="bx bxs-star"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                </blockquote>
                            </div>
                        </div>

                      
                        <ol class="carousel-indicators" data-aos="fade-down">
                            <li data-target="#quote-carousel" data-slide-to="0" class="active">
                                <img class="img-responsive" src="assets/img/artificial-intelligence/user1.jpg" alt="" />
                            </li>
                            <li data-target="#quote-carousel" data-slide-to="1">
                                <img class="img-responsive" src="assets/img/artificial-intelligence/user2.jpg" alt="" />
                            </li>
                            <li data-target="#quote-carousel" data-slide-to="2">
                                <img class="img-responsive" src="assets/img/artificial-intelligence/user1.jpg" alt="" />
                            </li>
                        </ol>

                   
                        <a data-slide="prev" href="#quote-carousel" class="left carousel-control">
                            <i class="fa fa-chevron-left"></i>
                        </a>
                        <a data-slide="next" href="#quote-carousel" class="right carousel-control">
                            <i class="fa fa-chevron-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <div class="full-row" #seprator id="seprator">
        <div class="container-fluid">
            <h6>
                Want to Improve the Experience of Your Customers? Our Dedicated Team Is Here to Help You Out!


            </h6>
            <a class="btns btn-primarys" routerLink="/contact">
                CONTACT US
            </a>
        </div>
    </div>


    <!-- Clients Review Area -->
    <!-- <div class="clients-review-area with-linear-gradient-color ptb-100">
    <div class="container">
        <div class="section-title title-with-underline">
            <h2>
                Check What Our Clients <b>Feedback</b> On Our AI & Big Data Services
            </h2>
            <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit dolore magna aliqua.
            </p>
        </div>
        
        <div class="clients-review-slides clients-review-area ">
            <div class="clients-review-item">
                <ul class="rating">
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                </ul>
                <p>Lorem ipsum dolor sit amet consectetur adipiscing elit dui arcu purus nec morbi pretium molestie libero quis id morbi venenatis mi lorem ipsum dolor sit amet consectetur adipiscing elit.</p>
                <div class="client-info ">
                    <img src="assets/img/artificial-intelligence/user1.jpg" alt="image">
                    <h3>Thomas Adbadon</h3>
                    <p>Founder & CEO</p>
                </div>
            </div>

            <div class="clients-review-item">
                <ul class="rating">
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                </ul>
                <p>Lorem ipsum dolor sit amet consectetur adipiscing elit dui arcu purus nec morbi pretium molestie libero quis id morbi venenatis mi lorem ipsum dolor sit amet consectetur adipiscing elit.</p>
                <div class="client-info">
                    <img src="assets/img/artificial-intelligence/user2.jpg" alt="image">
                    <h3>Steven Smith</h3>
                    <p>Developer</p>
                </div>
            </div>

            <div class="clients-review-item">
                <ul class="rating">
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                </ul>
                <p>Lorem ipsum dolor sit amet consectetur adipiscing elit dui arcu purus nec morbi pretium molestie libero quis id morbi venenatis mi lorem ipsum dolor sit amet consectetur adipiscing elit.</p>
                <div class="client-info">
                    <img src="assets/img/artificial-intelligence/user2.jpg" alt="image">
                    <h3>Sarah Lucy</h3>
                    <p>Designer</p>
                </div>
            </div>

            <div class="clients-review-item">
                <ul class="rating">
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                </ul>
                <p>Lorem ipsum dolor sit amet consectetur adipiscing elit dui arcu purus nec morbi pretium molestie libero quis id morbi venenatis mi lorem ipsum dolor sit amet consectetur adipiscing elit.</p>
                <div class="client-info">
                    <img src="assets/img/artificial-intelligence/user1.jpg" alt="image">
                    <h3>Thomas Adbadon</h3>
                    <p>Founder & CEO</p>
                </div>
            </div>

            <div class="clients-review-item">
                <ul class="rating">
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                </ul>
                <p>Lorem ipsum dolor sit amet consectetur adipiscing elit dui arcu purus nec morbi pretium molestie libero quis id morbi venenatis mi lorem ipsum dolor sit amet consectetur adipiscing elit.</p>
                <div class="client-info">
                    <img src="assets/img/artificial-intelligence/user2.jpg" alt="image">
                    <h3>Steven Smith</h3>
                    <p>Developer</p>
                </div>
            </div>

            <div class="clients-review-item">
                <ul class="rating">
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                </ul>
                <p>Lorem ipsum dolor sit amet consectetur adipiscing elit dui arcu purus nec morbi pretium molestie libero quis id morbi venenatis mi lorem ipsum dolor sit amet consectetur adipiscing elit.</p>
                <div class="client-info">
                    <img src="assets/img/artificial-intelligence/user2.jpg" alt="image">
                    <h3>Sarah Lucy</h3>
                    <p>Designer</p>
                </div>
            </div>
        </div>
    </div>
</div> -->

    <!-- AI Blog Area -->
    <!-- <div class="ai-blog-area pt-100 pb-70">
    <div class="container">
        <div class="section-title title-with-underline">
            <h2>Latest Blog and News Don’t Miss Any <b>Updates</b> And News!</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit dolore magna aliqua.</p>
        </div>

        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6">
                <div class="ai-blog-card">
                    <div class="entry-thumbnail">
                        <a href="single-blog.html"><img src="assets/img/artificial-intelligence/blog/blog-1.jpg" alt="image"></a>
                    </div>
                    <div class="entry-post-content">
                        <div class="tag">
                            <a href="single-blog.html">TECHNOLOGY</a>
                        </div>
                        <h3><a href="single-blog.html">Making Peace With The Feast Or Famine Of Freelancing</a></h3>
                        <ul class="entry-meta">
                            <li>By <a href="blog-1.html">Thomas Kelbin</a></li>
                            <li>17th January</li>
                            <li>0 Comment</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="ai-blog-card">
                    <div class="entry-thumbnail">
                        <a href="single-blog.html"><img src="assets/img/artificial-intelligence/blog/blog-2.jpg" alt="image"></a>
                    </div>
                    <div class="entry-post-content">
                        <div class="tag">
                            <a href="single-blog.html">TECHNOLOGY</a>
                        </div>
                        <h3><a href="single-blog.html">I Used The Web For A Day On A 50 MB Budget</a></h3>
                        <ul class="entry-meta">
                            <li>By <a href="blog-1.html">Thomas Kelbin</a></li>
                            <li>17th January</li>
                            <li>0 Comment</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="ai-blog-card">
                    <div class="entry-thumbnail">
                        <a href="single-blog.html"><img src="assets/img/artificial-intelligence/blog/blog-3.jpg" alt="image"></a>
                    </div>
                    <div class="entry-post-content">
                        <div class="tag">
                            <a href="single-blog.html">TECHNOLOGY</a>
                        </div>
                        <h3><a href="single-blog.html">Here Are The 5 Most Telling Signs Of Micromanagement</a></h3>
                        <ul class="entry-meta">
                            <li>By <a href="blog-1.html">Thomas Kelbin</a></li>
                            <li>17th January</li>
                            <li>0 Comment</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>  
</div> -->

    <!-- AI Subscribe Area -->
    <!-- <div class="ai-subscribe-area ptb-100">
    <div class="container">
        <div class="ai-subscribe-content">
            <h2>Get The Best Blog <b>Stories</b> Into Your Inbox!</h2>
            <form class="newsletter-form" data-toggle="validator">
                <input type="email" class="input-newsletter" placeholder="Enter your email" name="EMAIL" required autocomplete="off">
                <button type="submit">Subscribe</button>
                <div id="validator-newsletter" class="form-result"></div>
                <div class="newsletter-checkbox-btn">
                    <input class="inp-cbx" id="cbx" type="checkbox">
                    <label class="cbx" for="cbx">
                        <span>
                            <svg width="12px" height="10px" viewbox="0 0 12 10">
                                <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                            </svg>
                        </span>
                        <span>I agree submit data is being collected store</span>
                    </label>
                </div>
            </form>
        </div>
    </div>

    <div class="ai-subscribe-shape">
        <img src="assets/img/artificial-intelligence/subscribe-shape.png" alt="image">
    </div>
</div> -->
</section>






<!-- <div class="main-page">
        <div class="container-fluid">
            <div class="main-page-content padding-horizontal flex">
                <div class="row">
                    <div
                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12 order-lg-1 order-md-1 order-sm-2 order-xs-2">
                        <div class="main-content-text">
                            <h1>
                                Customer AI & Big Data Solution for Analystics
                            </h1>
                            <p>
                                Vocbot   revolutionizes your calling
                                operations, offering an AI-powered virtual call
                                centre at zero infrastructure cost. Achieve a
                                70% AHT reduction for a substantial increase in
                                CSAT.
                            </p>

                            <ul class="banner-btn" style="margin-top: 60px">
                                <li>
                                    <a routerLink="/contact" class="btn btn-primary" data-aos="zoom-in"
                                        style="padding-top: 13px">
                                        Get Started
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.youtube.com/watch?v=bk7McNUjWgw"
                                        class="video-btn popup-youtube mt- -1">
                                        <i class="fa-solid fa-play"></i>
                                        Watch
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div
                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12 order-lg-2 order-md-2 order-sm-1 order-xs-1">
                        <div class="main-image image-align">
                            <img src="assets/img/voice-bot.png" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="solution-banner-shape-1">
                <img src="assets/img/ai-solution/banner/shape1.png" alt="image" />
            </div>
            <div class="solution-banner-shape-2">
                <img src="assets/img/shape3.png" alt="image" />
            </div>
            <div class="solution-banner-shape">
                <img src="assets/img/shape.png" alt="image" />
            </div>
            <div class="solution-banner-shape-3">
                <img src="assets/img/shape2.png" alt="image" />
            </div>
             <div class="solution-banner-shape-4">
            <img src="assets/img/sound-wave.png" alt="image" />
        </div>  
        </div>
    </div> -->

<!-- Overview Features Area -->
<!-- <div class="overview-features-area pb-70">
    <div class="container-fluid">
        <div class="section-title title-with-underline" data-aos="fade-down">
            <h2>See Wide Range Of Our Services With Artificial Intelligence</h2>
            <p>
                Explore a diverse array of services empowered by Artificial
                Intelligence with us.
            </p>
            <img src="assets/img/RO.gif" style="height: 30px" />
        </div>

        <div class="row">
            <div class="col-lg-4 col-sm-12" data-aos="zoom-in-down">
             <div class="overview-features-card">
                    <div class="features-image">
                        <img src="assets/img/ai-solution/features/inound.png" alt="image">
                    </div>
                    <div class="features-content">
                        <h3>Inbound Call Center</h3>
                        <img src="assets/img/RO.gif" style="height: 18px;">
                        <p>
                            Unlock the potential of AI speech bots to enhance your inbound calls intelligently. Optimize processes, reduce wait times, and seamlessly integrate automation with human interaction for effective service delivery and increased customer satisfaction.
                        </p>
                           <div class="overlay"></div>
                       <a routerLink="/inBound" class="features-btn" style="position: absolute; bottom: 25px; right: 40px;"> -->
<!-- <button routerLink="/inBound" class="card-btn">Click</button>
                         
                    </div>
                </div> -->
<!-- <div class="e-card playing">
                    <div class="image"></div>

                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="infotop">
                        <div class="features-image">
                            <img
                                src="assets/img/ai-solution/features/inound.png"
                                alt="image"
                            />
                        </div>
                        <div class="features-content">
                            <h3>Inbound Call Center</h3>
                            <p>
                                Unlock the potential of AI speech bots to
                                enhance your inbound calls intelligently.
                                Optimize processes, reduce wait times, and
                                seamlessly integrate automation with human
                                interaction for effective service delivery and
                                increased customer satisfaction.
                            </p>
                            <a
                                routerLink="/inBound"
                                class="features-btn"
                                style="
                                    position: absolute;
                                    bottom: -52px;
                                    right: 32px;
                                "
                            >
                                <div class="row">Read More</div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-12" data-aos="zoom-in-down">
                <div class="overview-features-card">
                    <div class="features-image">
                        <img src="assets/img/ai-solution/features/outbound.png" alt="image">
                    </div>
                    <div class="features-content">
                        <h3>
                            Outbound Marketing
                            
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 18px;">
                        
                        <p>
                            Transform your outbound marketing with VocBot's potent capabilities. Elevate efficiency with its diverse features. Seamlessly scale operations, ensuring effortless transitions. Experience a powerful tool for elevated marketing endeavors.  
                        </p>
                        <a routerLink="/outBound" class="features-btn" style="position: absolute; bottom: 25px; right: 40px;">
                            <div class="row">
                                Learn More
                            </div>
                        </a>
                    </div>
                </div> -->
<!-- <div class="e-card playing">
                    <div class="image"></div>

                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="infotop">
                        <div class="features-image">
                            <img
                                src="assets/img/ai-solution/features/outbound.png"
                                alt="image"
                            />
                        </div>
                        <div class="features-content">
                            <h3>Outbound Marketing</h3>
                            <p>
                                Transform your outbound marketing with VocBot's
                                potent capabilities. Elevate efficiency with its
                                diverse features. Seamlessly scale operations,
                                ensuring effortless transitions. Experience a
                                powerful tool for elevated marketing endeavors.
                            </p>
                            <a
                                routerLink="/outBound"
                                class="features-btn"
                                style="
                                    position: absolute;
                                    bottom: -52px;
                                    right: 32px;
                                "
                            >
                                <div class="row">Read More</div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-12" data-aos="zoom-in-down"> -->
<!-- <div class="overview-features-card">
                    <div class="features-image">
                        <img src="assets/img/ai-solution/features/whatsapp-144.png" alt="image" style="height: 65px !important;" >
                    </div>
                    <div class="features-content">
                        <h3>Bulk WhatsApp Sender</h3>
                        <img src="assets/img/RO.gif" style="height: 18px;">
                        <p>
                            Empower your messaging strategy with the Bulk WhatsApp Sender feature on Vocbot  . Seamlessly send messages at scale, enhancing communication efficiency.you can reach a broader audience, ensuring that your messages are delivered promptly and effectively.
                        </p>
                        <a routerLink="/bulkWhatsApp" class="features-btn" style="position: absolute; bottom: 25px; right: 40px;">
                            <div class="row">
                                Learn More
                            </div>
                        </a>
                    </div>
                </div> -->
<!-- <div class="e-card playing">
                    <div class="image"></div>

                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="infotop">
                        <div class="features-image">
                            <img
                                src="assets/img/ai-solution/features/whatsapp-144.png"
                                alt="image"
                                style="max-width: 16%"
                            />
                        </div>
                        <div class="features-content">
                            <h3>Bulk WhatsApp Sender</h3>
                            <p>
                                Empower your messaging strategy with the Bulk
                                WhatsApp Sender feature on Vocbot  . Seamlessly
                                send messages at scale, enhancing communication
                                efficiency.you can reach a broader audience,
                                ensuring that your messages are delivered
                                promptly and effectively.
                            </p>
                            <a
                                routerLink="/bulkWhatsApp"
                                class="features-btn"
                                style="
                                    position: absolute;
                                    bottom: -52px;
                                    right: 32px;
                                "
                            >
                                <div class="row">Read More</div>
                            </a>
                        </div>
                    </div>
                </div> -->
<!-- </div> -->

<!-- <div class="col-lg-3 col-sm-6">
                <div class="overview-features-card">
                    <div class="features-image">
                        <img src="assets/img/ai-solution/features/features3.png" alt="image" style="height: 56px !important;">
                    </div>
                    <div class="features-content">
                        <h3>Promotional Calls</h3>
                        <p>
                            Lorem ipsum dolor sit amet consectetur adipiscing elit nulla faucibus pulvinar iaculis et eu arcu mauris euismod duis.
                        </p>
                        <a routerLink="/promotional-calls" class="features-btn" style="position: absolute; bottom: 25px; right: 40px;">
                            <div class="row">
                                Learn More
                            </div>
                        </a>
                    </div>
                </div>
            </div> -->
<!-- </div>
    </div>
</div>  -->
<!-- Industries Area -->
<!-- <div class="industries-area with-bg-color pt-100 pb-70">
    <div class="container">
        <div class="row justify-content-center" style="margin-top: 50px !important;"> -->
<!-- <div class="col-lg-3 col-md-12"> -->
<!-- <div class="industries-section-content">
                    <h3>Wide Range Of <b>Industries</b></h3>
                    <p>Lorem ipsum dolor sit am adipisc elit sed do eiusmod. Demis dolor seit.</p> -->
<!-- <div class="industries-btn">
                        <a href="#" class="btn btn-primary">Learn More</a>
                    </div> -->
<!-- </div> -->
<!-- </div> -->

<!-- <div class="col-lg-9 col-md-12"> -->
<!-- <div class="row" style="margin-top: 30px !important;">
                    <div class="col-lg-4 col-sm-6">
                        <div class="industries-card">
                            <div class="content">
                                <img src="assets/img/artificial-intelligence/industries/industries-1.png" alt="image">
                                <h3>Machine Learning</h3>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-sm-6">
                        <div class="industries-card">
                            <div class="content">
                                <img src="assets/img/artificial-intelligence/industries/industries-7.png" alt="image">
                                <h3>Manufacturing</h3>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-sm-6">
                        <div class="industries-card">
                            <div class="content">
                                <img src="assets/img/artificial-intelligence/industries/industries-8.png" alt="image">
                                <h3>Healthcare</h3>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-sm-6">
                        <div class="industries-card">
                            <div class="content">
                                <img src="assets/img/artificial-intelligence/industries/industries-2.png" alt="image">
                                <h3>Robotics And Drones</h3>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-sm-6">
                        <div class="industries-card">
                            <div class="content">
                                <img src="assets/img/artificial-intelligence/industries/industries-3.png" alt="image">
                                <h3>Image Processing</h3>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-sm-6">
                        <div class="industries-card">
                            <div class="content">
                                <img src="assets/img/artificial-intelligence/industries/industries-4.png" alt="image">
                                <h3>AI For Cloud Service</h3>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="industries-btn" style="margin-top: 50px; text-align: center !important;">
                    <a href="#" class="btn btn-primary">Learn More</a>
                </div> -->
<!-- </div> -->
<!-- </div>
    </div>
</div> -->
<!-- <div class="container">
    <div class="counter-inner-box pt-100 pb-70">
        <div class="row justify-content-center">
            <div class="col-lg-3 col-sm-6">
                <div class="counter-card">
                    <div class="icon">
                        <i class='bx bx-check-shield'></i>
                    </div>
                    <h3>
                        <span class="odometer" data-count="2460">2460</span>
                        <span class="sign-icon">+</span>
                    </h3>
                    <p>Completed project dolor sit amet.</p>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6">
                <div class="counter-card">
                    <div class="icon">
                        <i class='bx bx-user-circle'></i>
                    </div>
                    <h3>
                        <span class="odometer" data-count="1800">1800</span>
                        <span class="sign-icon">+</span>
                    </h3>
                    <p>Satisfied clients dolor sit lorem  amet.</p>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6">
                <div class="counter-card">
                    <div class="icon">
                        <i class='bx bx-layer'></i>
                    </div>
                    <h3>
                        <span class="odometer" data-count="832">832</span>
                        <span class="sign-icon">+</span>
                    </h3>
                    <p>Industries served dolor sit amet.</p>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6">
                <div class="counter-card">
                    <div class="icon">
                        <i class='bx bx-buildings'></i>
                    </div>
                    <h3>
                        <span class="odometer" data-count="12">12</span>
                        <span class="sign-icon">+</span>
                    </h3>
                    <p>Office brunches around the world.</p>
                </div>
            </div>
        </div>

        <div class="counter-shape">
            <img src="assets/img/ai-solution/counter-shape.png" alt="image">
        </div>
    </div>
</div> -->